import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../data/data.service';
import { Student } from '../data/student';
import { Assessment, StudentAssessmentDetails } from '../data/assessments';
import { BaseComponent } from '../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RedirectService } from '../redirect.service';
import { OrganizationService } from '../organization.service';
import { Location } from '@angular/common';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-request-assessment-modal',
  templateUrl: './request-assessment-modal.component.html',
  styleUrls: ['./request-assessment-modal.component.scss']
})

export class RequestAssessmentModalComponent extends BaseComponent implements OnInit {
  constructor(
    protected route: ActivatedRoute,
    protected authService: AuthService,
    protected organizationService: OrganizationService,
    protected redirectService: RedirectService,
    protected router: Router,
    protected dataService: DataService,
    protected location: Location,
    private modalService: NgbModal
  ) {
    super(route, authService, organizationService, redirectService, router, dataService, location);
  }

  @ViewChild('modal') modal: NgbActiveModal;
  @Output() dataRefresh = new EventEmitter();

  @Input() assessment: Assessment;
  @Input() students: Student[];
  @Input() studentAssessmentDetails: StudentAssessmentDetails[];

  selectedStudents: { student: Student, attempted: boolean, include: boolean }[];

  isWaiting: boolean = false;

  modalRef: NgbActiveModal;

  open() {
    this.refreshSelectedStudents();
    this.modalRef = this.modalService.open(this.modal, { size: 'lg' });
  }

  refreshSelectedStudents() {
    console.log(this.studentAssessmentDetails);
    this.selectedStudents = this.students.map(student => ({
      student: student,
      attempted: (this.studentAssessmentDetails.filter(x => x.StudentID === student.ID)[0].Passed === false),
      include: false
    }));
  }

  isInputValid() {
    return this.selectedStudents.some(s => s.include);
  }

  getSelectedStudentsText(): string {
    let requestedStudentsCount = this.selectedStudents.filter(s => s.include).length;

    if (requestedStudentsCount === 1) return "1 Student";
    if (requestedStudentsCount === this.selectedStudents.length) return "All Students";
    if (requestedStudentsCount > 1) return `${requestedStudentsCount} Students`;
    return "No students selected";
  }

  selectAllStudents() {
    this.selectedStudents.forEach(s => s.include = true);
  }


  selectAttemptedStudents() {
    this.selectedStudents.forEach(s => s.include = s.attempted);
  }

  deselectAllStudents() {
    this.selectedStudents.forEach(s => s.include = false);
  }

  toggleStudent(student: any): void {
    student.include = !student.include;
  }

  requestAssessment(): void {
    this.isWaiting = true;

    this.dataService.requestAssessment(this.assessment.ID, this.selectedStudents.filter(s => s.include).map(s => s.student.ID)).subscribe(o => {
      this.isWaiting = false;

      if (o) {
        Swal.fire({
          title: "Success!",
          text: "The assessment has been requested from the selected students.",
          type: "success",
          showConfirmButton: false,
          timer: 1000
        }).then(() => {
          this.dataRefresh.emit(o);
          this.modalService.dismissAll();
        });
      }
    },
      err => Swal.fire("Oops!", err.message, "error").then(() => {
        this.dataRefresh.emit(err);
        this.modalService.dismissAll();
      })
    );
  }
}
